import { z } from "zod";

export const updateRoomResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        id: z.string().uuid(),
        property_id: z.string().uuid(),
        invoice_number: z.string(),
        invoice_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
        room_id: z.nullable(z.string().uuid()),
    }),
});

export type UpdateRoomResponse = z.infer<typeof updateRoomResponseSchema>;